import { Loadable } from '../../Loadable';

export const AsyncAddFeature = Loadable(() => import('./Add'));
export const AsyncFeaturesList = Loadable(() => import('./List'));
